export default __webpack_public_path__ + "static/media/learner-dashboard-basic.d560a9cf.png";